import React from 'react';
import { Block, UiDiv, UiText } from '@webfox-sc/core';
import LoginForm from '../LoginForm';

const AuthPage = () => {
  return (
    <>
      {IS_DEACTIVATED && (
        <UiDiv gridColumn="1 / 4" background="red" textAlign="center" marginTop="s" padding="s">
          <UiText>
            Diese Version der SMG-App wurde deatktiviert. Bitte benutzen Sie die neue Version unter:<br />
            <a
              href="https://yellow-rock-0f292ec03.5.azurestaticapps.net/"
              target="_blank"
              style={{ color: 'white' }}
            >
              https://yellow-rock-0f292ec03.5.azurestaticapps.net/
            </a>
          </UiText>
        </UiDiv>
      )}
      <Block justifyContent="center" paddingTop="200px">
        <LoginForm />
      </Block>
    </>
  );
};

export default AuthPage;
